import { render } from "./TheJ05ChatForms.vue?vue&type=template&id=7c8bef08&scoped=true&ts=true"
import script from "./TheJ05ChatForms.vue?vue&type=script&lang=ts"
export * from "./TheJ05ChatForms.vue?vue&type=script&lang=ts"

import "./TheJ05ChatForms.vue?vue&type=style&index=0&id=7c8bef08&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8bef08"]])

export default __exports__